// tabs-terminos.js
(function () {
  "use strict";

  // CONFIG
  const API_VERSION = "2026-07";
  const itemsPerPage = 12;

  const PAGES_QUERY = `
    query TabsTerminos($after: String) {
      pages(first: 250, after: $after) {
        pageInfo { hasNextPage endCursor }
        nodes {
          title
          handle
          body
          metafields(identifiers: [
            { namespace: "custom", key: "year" },
            { namespace: "custom", key: "date_terms" },
            { namespace: "custom", key: "icono" }
          ]) {
            key
            value
            type
            reference {
              ... on MediaImage { image { url } }
              ... on GenericFile { url }
            }
          }
        }
      }
    }`;

  async function fetchAllPages(token) {
    let allNodes = [];
    let hasNextPage = true;
    let endCursor = null;

    while (hasNextPage) {
      const res = await fetch(`/api/${API_VERSION}/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token
        },
        body: JSON.stringify({ query: PAGES_QUERY, variables: { after: endCursor } })
      });
      const data = await res.json();

      if (data?.errors) console.error("Storefront API errors:", data.errors);

      const pages = data?.data?.pages;
      if (!pages) break;

      allNodes = allNodes.concat(pages.nodes);

      hasNextPage = pages.pageInfo.hasNextPage;
      endCursor = pages.pageInfo.endCursor;
    }

    return allNodes;
  }

  // Helpers
  const $ = sel => document.querySelector(sel);
  const $$ = sel => Array.from(document.querySelectorAll(sel));
  const stripHtml = str => (str || "").replace(/<[^>]*>/g, "").trim();
  const safeStr = v => (v === undefined || v === null) ? "" : String(v).trim();
  const safeDate = (d) => {
    if (!d) return new Date(0);
    const parsed = new Date(d);
    if (!isNaN(parsed)) return parsed;
    // try YYYYMMDD
    const onlyDigits = d.replace(/\D/g, "");
    if (/^\d{8}$/.test(onlyDigits)) {
      const y = onlyDigits.slice(0, 4);
      const m = onlyDigits.slice(4, 6);
      const day = onlyDigits.slice(6, 8);
      const s = `${y}-${m}-${day}`;
      const p = new Date(s);
      if (!isNaN(p)) return p;
    }
    return new Date(0);
  };

  async function init() {
    const tabsContainer = $("#tabs-container-links");
    const selectMobile = $("#tab-select");
    const tabsContentWrapper = $("#tabs-content-wrapper");
    const section = $(".tabs-carousel-section");

    if (!tabsContainer || !selectMobile || !tabsContentWrapper) {
      console.error("Estructura DOM no encontrada. Asegúrate de tener #tabs-container-links, #tab-select y #tabs-content-wrapper.");
      return;
    }

    const token = section ? section.dataset.storefrontToken : "";
    if (!token) {
      console.error("Tabs terminos: falta el Storefront API token en la configuración de la sección.");
      return;
    }

    // Fetch
    let nodes;
    try {
      nodes = await fetchAllPages(token);
    } catch (err) {
      console.error("Error al consultar Storefront API:", err);
      return;
    }

    const pagesData = nodes.map(node => {
      const metafields = {};
      (node.metafields || []).forEach(mf => {
        if (!mf) return; // null cuando la página no tiene el metacampo
        if (mf.type === "file_reference") {
          // MediaImage trae image.url; un SVG subido como GenericFile trae url
          metafields[mf.key] = mf.reference?.image?.url || mf.reference?.url || "";
        } else {
          metafields[mf.key] = mf.value;
        }
      });

      return {
        title: safeStr(node.title),
        handle: safeStr(node.handle),
        body: safeStr(node.body),
        year: safeStr(metafields.year),
        date_terms: safeStr(metafields.date_terms),
        icono: safeStr(metafields.icono),
        url: `/pages/${safeStr(node.handle)}`
      };
    });

    // Group by year
    const pagesByYear = {};
    pagesData.forEach(p => {
      if (!p.year) return; // skip if no year
      if (!pagesByYear[p.year]) pagesByYear[p.year] = [];
      pagesByYear[p.year].push(p);
    });

    // Sort years descending (numeric where possible)
    const years = Object.keys(pagesByYear).sort((a, b) => {
      const na = Number(a);
      const nb = Number(b);
      if (!isNaN(na) && !isNaN(nb)) return nb - na;
      return b.localeCompare(a);
    });

    if (years.length === 0) {
      tabsContainer.innerHTML = "<p>No hay años disponibles.</p>";
      return;
    }

    // Render tabs and mobile select
    years.forEach((year, idx) => {
      const a = document.createElement("a");
      a.className = `tab-link ${idx === 0 ? "active" : ""}`;
      a.dataset.tab = year;
      a.href = "#";
      a.textContent = year;
      a.addEventListener("click", (e) => {
        e.preventDefault();
        switchTab(year);
      });
      tabsContainer.appendChild(a);

      const option = document.createElement("option");
      option.value = year;
      option.textContent = year;
      if (idx === 0) option.selected = true;
      selectMobile.appendChild(option);
    });

    selectMobile.addEventListener("change", function () {
      const selected = this.value;
      switchTab(selected);
    });

    // Render tab contents (cards grouped per year, sorted by date desc)
    years.forEach((year, idx) => {
      const container = document.createElement("div");
      container.className = `tab-content ${idx === 0 ? "active" : ""}`;
      container.id = year;

      const wrapper = document.createElement("div");
      wrapper.className = "cards-wrapper";
      wrapper.dataset.tab = year;

      // sort pages by date_terms desc
      pagesByYear[year].sort((a, b) => safeDate(b.date_terms) - safeDate(a.date_terms));

      pagesByYear[year].forEach(page => {
        const card = document.createElement("div");
        card.className = "card";
        const titleText = stripHtml(page.title);
        const contentText = stripHtml(page.body);
        const titleTruncated = titleText.length > 40 ? titleText.slice(0, 40) + "..." : titleText;
        const contentTruncated = contentText.length > 180 ? contentText.slice(0, 180) + "..." : contentText;

        card.innerHTML = `
          <div class="left_card">
            ${page.icono ? `<img src="${page.icono}" width="46" height="46" alt="Icono Terminos">` : ""}
            <h3>${titleTruncated}</h3>
            <p>${contentTruncated}</p>
          </div>
          <div class="right_card">
            <a href="${page.url}">
              <img src="https://cdn.shopify.com/s/files/1/0555/7695/2966/files/ctaCardTerms.svg?v=1747273868" alt="Boton Card">
            </a>
          </div>
        `;
        wrapper.appendChild(card);
      });

      container.appendChild(wrapper);

      // Pagination controls (solo si hay más items que itemsPerPage)
      const total = pagesByYear[year].length;
      if (total > itemsPerPage) {
        const controlsDiv = document.createElement("div");
        controlsDiv.className = "pagination-controls";
        controlsDiv.dataset.tab = year;

        const btnPrev = document.createElement("button");
        btnPrev.className = "prev-page";
        btnPrev.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0555/7695/2966/files/iconLeftArrow.svg?v=1747149158" /> Anterior`;

        const numbersDiv = document.createElement("div");
        numbersDiv.className = "pagination-numbers";

        const btnNext = document.createElement("button");
        btnNext.className = "next-page";
        btnNext.innerHTML = `Siguiente <img src="https://cdn.shopify.com/s/files/1/0555/7695/2966/files/iconRightArrow.svg?v=1747149158" />`;

        controlsDiv.appendChild(btnPrev);
        controlsDiv.appendChild(numbersDiv);
        controlsDiv.appendChild(btnNext);

        const infoP = document.createElement("p");
        infoP.className = "pagination-info";
        infoP.dataset.tab = year;
        infoP.innerHTML = `Mostrando <span class="showing-count">0</span> de <span class="total-count">${total}</span>
          <span class="current-page" style="display:none;">1</span>
          <span class="total-pages" style="display:none;">${Math.ceil(total / itemsPerPage)}</span>`;

        container.appendChild(controlsDiv);
        container.appendChild(infoP);
      }

      tabsContentWrapper.appendChild(container);
    });

    // Switch tab function
    function switchTab(year) {
      // active tab link
      $$(".tab-link").forEach(t => t.classList.toggle("active", t.dataset.tab === year));
      // active content
      $$(".tab-content").forEach(c => c.classList.toggle("active", c.id === year));
      // mobile select
      if (selectMobile.value !== year) selectMobile.value = year;
      // init pagination for that tab
      paginateTab(year);
    }

    // Pagination function (scoped per tab)
    function paginateTab(tabId) {
      const wrapper = document.querySelector(`.cards-wrapper[data-tab="${tabId}"]`);
      if (!wrapper) return;
      const cards = Array.from(wrapper.querySelectorAll(".card"));
      const total = cards.length;
      const totalPages = Math.ceil(total / itemsPerPage);
      if (totalPages === 0) return;
      let currentPage = 1;

      const info = document.querySelector(`.pagination-info[data-tab="${tabId}"]`);
      const controls = document.querySelector(`.pagination-controls[data-tab="${tabId}"]`);
      const btnPrev = controls ? controls.querySelector(".prev-page") : null;
      const btnNext = controls ? controls.querySelector(".next-page") : null;
      const numbersContainer = controls ? controls.querySelector(".pagination-numbers") : null;

      function renderPage() {
        cards.forEach((card, i) => {
          const visible = (i >= (currentPage - 1) * itemsPerPage && i < currentPage * itemsPerPage);
          // display as flex to keep original layout
          card.style.display = visible ? "flex" : "none";
        });

        if (info) {
          const showingCount = Math.min(currentPage * itemsPerPage, total);
          info.querySelector(".showing-count").textContent = showingCount;
          info.querySelector(".total-count").textContent = total;
          info.querySelector(".current-page").textContent = currentPage;
          info.querySelector(".total-pages").textContent = totalPages;
        }

        if (numbersContainer) updatePaginationNumbers();
      }

      function updatePaginationNumbers() {
        if (!numbersContainer) return;
        numbersContainer.innerHTML = "";
        // Simple numeric buttons; you can optimize for long paginations
        for (let i = 1; i <= totalPages; i++) {
          const btn = document.createElement("button");
          btn.className = "page-number";
          btn.textContent = i;
          if (i === currentPage) btn.classList.add("active");
          btn.addEventListener("click", () => {
            currentPage = i;
            renderPage();
          });
          numbersContainer.appendChild(btn);
        }
      }

      if (btnPrev) {
        btnPrev.onclick = () => {
          if (currentPage > 1) {
            currentPage--;
            renderPage();
          }
        };
      }
      if (btnNext) {
        btnNext.onclick = () => {
          if (currentPage < totalPages) {
            currentPage++;
            renderPage();
          }
        };
      }

      // First render
      renderPage();
    }

    // Initialize first active tab's pagination
    const firstTab = document.querySelector(".tab-link.active");
    if (firstTab) paginateTab(firstTab.dataset.tab);
  } // end init

  // start
  document.addEventListener("DOMContentLoaded", init);
})();
